function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'black': 'rgb(11, 11, 11)','salmon': 'rgb(243, 212, 207)','green': 'rgb(191, 205, 188)','light-green': 'rgb(231, 232, 224)','blue': 'rgb(117, 174, 215)','light-blue': 'rgb(220, 228, 250)','light-brown': 'rgb(217, 190, 169)','peanut-butter': 'rgb(228, 170, 96)','gray': 'rgb(232, 233, 235)','white': 'rgb(255, 255, 255)','khaki': 'rgb(172, 156, 127)','dark-green': 'rgb(48, 70, 58)','dark-blue': 'rgb(51, 77, 168)','navy': 'rgb(61, 61, 86)','red': 'rgb(229, 47, 46)','charcoal-heather': 'rgb(57, 57, 57)','light-pink': 'rgb(243, 223, 205)','oatmeal-heather': 'rgb(222, 221, 212)','heather-gray': 'rgb(206, 206, 206)','apricot': 'rgb(222, 214, 209)','navy-blue': 'rgb(28, 26, 43)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
